export default "<mat-progress-spinner [mode]=\"'indeterminate'\"></mat-progress-spinner>\n"